import React from "react";
import { Link } from "react-router-dom";
import { Users, Radio } from "lucide-react";
import { StarRating, Money, Badge } from "@/components/common";

export default function CourseCard({ course }) {
  const price = course.discount_price || course.price;
  const hasDiscount = course.discount_price && course.discount_price < course.price;
  return (
    <Link
      to={`/courses/${course.id}`}
      data-testid={`course-card-${course.id}`}
      className="group bg-white rounded-xl border border-border overflow-hidden hover:-translate-y-1 hover:shadow-[0_12px_40px_rgb(10_17_40/0.12)] transition-all duration-200 flex flex-col"
    >
      <div className="relative aspect-video overflow-hidden bg-muted">
        <img src={course.thumbnail} alt={course.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        {course.course_type === "live" && (
          <span className="absolute top-3 left-3 bg-crimson text-white text-xs font-semibold px-2 py-1 rounded-full flex items-center gap-1">
            <Radio size={12} /> LIVE
          </span>
        )}
        <span className="absolute top-3 right-3"><Badge tone="amber">{course.level}</Badge></span>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-heading font-semibold text-navy line-clamp-2 leading-snug">{course.title}</h3>
        <p className="text-sm text-muted-foreground mt-1">by {course.instructor_name}</p>
        <div className="flex items-center gap-3 mt-2 text-sm">
          <StarRating value={course.rating} showValue />
          <span className="text-muted-foreground flex items-center gap-1"><Users size={13} /> {course.enrolled_count}</span>
        </div>
        <div className="mt-auto pt-3 flex items-center gap-2">
          <span className="font-heading font-black text-lg text-navy"><Money amount={price} /></span>
          {hasDiscount && <span className="text-sm text-muted-foreground line-through"><Money amount={course.price} /></span>}
        </div>
      </div>
    </Link>
  );
}
